const H = ({ children }) => <div className="text-[11px] font-bold uppercase tracking-wider border-b border-slate-300 mt-3 mb-1">{children}</div>;

export default function ResumePreview({ c }) {
  if (!c) return null;
  const h = c.header;
  return (
    <div className="bg-white text-slate-900 rounded-lg px-8 py-6 text-[12px] leading-snug" style={{ fontFamily: "Calibri, Arial, sans-serif" }} data-testid="resume-preview">
      <div className="text-xl font-bold">{h.name}</div>
      <div>{[h.location_line, h.phone, h.email, h.linkedin, h.portfolio].filter(Boolean).join(" | ")}</div>
      <div>{c.work_authorization}</div>
      <div className="font-bold mt-1">{c.headline}</div>
      <H>Summary</H><div>{c.summary}</div>{c.years_statements?.length > 0 && <div>{c.years_statements.join("; ")}</div>}
      <H>Skills</H>{c.skills_groups.map((g) => <div key={g.category}><b>{g.category}:</b> {g.items.join(", ")}</div>)}
      <H>Experience</H>
      {c.experience.map((r) => (
        <div key={r.role_id} className="mt-1.5">
          <div className="flex"><span><b>{r.title}</b>, {r.company}{r.company_descriptor ? ` (${r.company_descriptor})` : ""}{r.location ? `, ${r.location}` : ""}</span><span className="ml-auto whitespace-nowrap">{r.start} – {r.end}</span></div>
          <ul className="list-disc pl-5">{r.bullets.map((b, i) => <li key={i}>{b.text}</li>)}</ul>
        </div>
      ))}
      {c.education?.length > 0 && <><H>Education</H>{c.education.map((e, i) => <div key={i} className="flex"><span><b>{e.degree}</b>, {e.school}</span><span className="ml-auto">{e.end}</span></div>)}</>}
      {c.certifications?.filter(Boolean).length > 0 && <><H>Certifications</H><ul className="list-disc pl-5">{c.certifications.filter(Boolean).map((x) => <li key={x}>{x}</li>)}</ul></>}
    </div>
  );
}
